export default __webpack_public_path__ + "static/media/OtpIcon.17a8d297.svg";